import {
    AnalyticsClient,
    AnalyticsEventType,
    AnalyticsProperties,
    AnalyticsPageviewProperties,
} from '@modernhealth/web-analytics';

export type {
    AnalyticsProperties as Properties,
    AnalyticsPageviewProperties as PageViewProperties,
};
export { AnalyticsEventType as EventType };

export const analyticsClient = new AnalyticsClient('web');
